import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Üldkasulik töö", -1)
const _hoisted_2 = {
  key: 0,
  class: "px-2 text-textDark text-justify mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_VoKuvaRohkem = _resolveComponent("VoKuvaRohkem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UldkasulikTooTabel = _resolveComponent("UldkasulikTooTabel")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_VoHoiatus, { class: "ma-2" }),
              _hoisted_1,
              (_ctx.lehePaiseTekst && _ctx.lehePaiseTekstLuhendatud)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createVNode(_component_VoKuvaRohkem, {
                      terveTekst: _ctx.lehePaiseTekst,
                      luhendatudTekst: _ctx.lehePaiseTekstLuhendatud
                    }, null, 8, ["terveTekst", "luhendatudTekst"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_UldkasulikTooTabel, {
                elemendid: _ctx.elemendid,
                laeb: _ctx.laeb,
                aluseId: _ctx.aluseId,
                broneeringuId: _ctx.broneeringuId,
                ajakavaId: _ctx.ajakavaId
              }, null, 8, ["elemendid", "laeb", "aluseId", "broneeringuId", "ajakavaId"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}